import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ButtonComponentStyles } from '../../../utils/utils';
import Button from '../../Button/button';
import './getInvolvedFrom.scss';
import FormField from '../../Form/FormField/formField';
import FormContainer from '../../Form/formContainer';
import { getInvolvedService } from '../../../services/getInvolved.service';

const GetInvolvedForm = () => {
  const [showSuccessState, setShowSuccessState] = React.useState(false);
  const [submittingHttpStatus, setSubmittingHttpStatus] = React.useState('success');
  const [alreadyExists, setAlreadyExists] = React.useState(false);
  const renderForm = () => {
    return (
      <Formik
        initialValues={{
          name: '',
          email: '',
        }}
        validationSchema={Yup.object({
          name: Yup.string().max(15, 'Must be 15 characters or less').required('Required'),
          email: Yup.string().email('Invalid email address').required('Required'),
        })}
        onSubmit={async (values, formikBag) => {
          setSubmittingHttpStatus('pending');
          getInvolvedService({ email: values.email, firstName: values.name, lastName: values.name })
            .then((res) => {
              res.json().then((data) => {
                if (data?.error_count > 0) {
                  setSubmittingHttpStatus('error');
                  if (data?.errors[0]?.error_code === 'ERROR_CONTACT_EXISTS') setAlreadyExists(true);
                  setShowSuccessState(false);
                } else {
                  setSubmittingHttpStatus('success');
                  formikBag.resetForm();
                  setShowSuccessState(true);
                  if (data?.errors[0]?.error_code === 'ERROR_CONTACT_EXISTS') setAlreadyExists(false);
                }
              });
            })
            .catch((err) => {
              console.error(err);
              setSubmittingHttpStatus('error');
              setShowSuccessState(false);
            });
        }}
      >
        <FormContainer>
          <FormField label="name" id="name" name="name" placeholder="ex. Jean Doe" title="Name" />
          <FormField label="email" title="EMAIL" className="form-control" id="email" name="email" placeholder="ex. jeandoe@gmail.com" type="email" />
          {alreadyExists && <div className="invalid-feedback">{alreadyExists && 'Email already exists!'}</div>}
          <Button
            buttonStyle={ButtonComponentStyles.PRIMARY}
            isDisabled={submittingHttpStatus === 'pending'}
            title={submittingHttpStatus === 'pending' ? 'Submitting...' : 'Submit'}
            type="submit"
          />
        </FormContainer>
      </Formik>
    );
  };
  const renderSuccessState = () => {
    return (
      <div className="success-message">
        <p>
          Thanks for your interest!
          <br /> We’ll get back to you shortly.
        </p>
      </div>
    );
  };
  return <div className="get-involved-form-container">{!showSuccessState ? renderForm() : renderSuccessState()}</div>;
};

export default GetInvolvedForm;
